import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { id: "philosophy", label: "Philosophy", href: "#philosophy" },
  { id: "journey", label: "The Journey", href: "#journey" },
  { id: "programmes", label: "Programmes", href: "#programmes" },
  { id: "practitioners", label: "Practitioners", href: "#practitioners" },
  { id: "contact", label: "Discovery Call", href: "#contact" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#2A241F] pt-20 text-[#F9F6F0]">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
      <div className="flex flex-wrap items-center justify-between gap-8">
        <span className="inline-flex items-center gap-3">
          <LogoMark className="h-6 w-6 text-[#E9B277]" />
          <span className="text-[11px] font-medium uppercase tracking-[0.35em] text-[#F9F6F0]/80">
            Ayurenew
          </span>
        </span>
        <nav className="flex flex-wrap items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`footer-link-${l.id}`}
              onClick={() => scrollToId(l.href)}
              className="text-[11px] font-medium uppercase tracking-[0.3em] text-[#F9F6F0]/60 transition-colors duration-300 hover:text-[#E9B277]"
            >
              {l.label}
            </button>
          ))}
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="text-[11px] font-medium uppercase tracking-[0.3em] text-[#F9F6F0]/40 transition-colors duration-300 hover:text-[#E9B277]"
          >
            Admin
          </Link>
        </nav>
      </div>

      <div className="pointer-events-none mt-16 select-none overflow-hidden" aria-hidden="true">
        <p className="whitespace-nowrap text-center font-serif text-[18vw] font-light leading-[0.85] tracking-tight text-[#F9F6F0]/[0.07]">
          AYURENEW
        </p>
      </div>

      <div className="flex flex-wrap items-center justify-between gap-4 border-t border-[#F9F6F0]/10 py-8">
        <p className="text-xs font-light tracking-wide text-[#F9F6F0]/50">
          © 2026 Ayurenew · Ancient wisdom, gently renewed.
        </p>
        <p className="text-xs font-light italic tracking-wide text-[#F9F6F0]/40">
          Everybody is different. Your healing should be too.
        </p>
      </div>
    </div>
  </footer>
);
